<template>
  <section class="add-document">
    <div class="container">
      <ul class="list-unstyled">
        <li
          class="row d-flex align-items-center"
          v-for="document in getUserProfile.documents"
          :key="document.id"
        >
          <div class="col-md-6 pl-0">
            <popper
              trigger="hover"
              :options="{
                placement: 'top',
                modifiers: { offset: { offset: '-80,10px' } },
              }"
            >
              <div class="popper">
                {{ document.is_default ? 'Deselect as primary CV' : 'Select as primary CV' }}
              </div>
              <div slot="reference">
                <i
                  ref="primaryIcon"
                  :id="document.id"
                  @click="setAsDefault"
                  title="Make primary CV"
                  class="fas fa-crown"
                  :class="[document.is_default ? 'crown-active' : '']"
                ></i>
              </div>
            </popper>

            <span class="d-flex">
              <i
                :class="[`mr-3 fa`, document.icon]"
                :style="`cursor: pointer; color: ${getIconColor(document.name)}; font-size: 22px`"
              ></i>
              <div>
                <span
                  v-if="document.name.split('.').pop() === 'pdf'"
                  class="open-document"
                  @click="onOpenDocPreview(document.id, document.name)"
                >
                  {{ document.name }}
                </span>
                <span
                  v-else
                  class="open-document"
                  @click="onOpenDocPreview(document.id, document.name)"
                >
                  {{ document.name }}
                </span>
              </div>
            </span>
          </div>
          <div class="col-md-3">
            <span class="date">{{
              document.created_at
                | formatDate({
                  format: getUserProfile.format_date,
                  timezone: getUserProfile.timezone,
                  hasHourAndMinutes: false,
                })
            }}</span>
          </div>
          <div class="col-md-3 pr-1 mobile-fix d-flex">
            <svgHelper
              @click.native="onDownloadDocument(document.id, document.name)"
              class="mr-3 ml-auto"
              style="cursor: pointer"
              name="download"
            ></svgHelper>
            <a data-toggle="modal" href="#deleteModal" @click="setDeleteDocument(document)">
              <svgHelper style="cursor: pointer" name="delete"></svgHelper>
            </a>
          </div>
        </li>
      </ul>

      <span v-if="!getUserProfile.documents.length" class="row d-flex align-items-center">
        <ErrorList name="noDocuments"></ErrorList
      ></span>
    </div>

    <!-- Delete Modal -->
    <div
      class="modal fade edit-modal"
      id="deleteModal"
      tabindex="-1"
      aria-labelledby="deleteModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">Remove File</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body text-center justify-content-center">
            <p>Please confirm that you want to remove {{ documentToDelete.name }}</p>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="onDeleteDocument"
            >
              Confirm
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ErrorList from '../common/errorsList.vue';

/* import CustomMainModal from '@/components/Modals/CustomMainModal';
import AddDocumentsBtnModal from './AddDocumentsBtnModal'; */

export default {
  components: {
    /* CustomMainModal, AddDocumentsBtnModal */ ErrorList,
  },
  data: () => ({
    showModal: false,
    documentToDelete: '',
    defaultDocs: [],
    isLoading: false,
  }),
  methods: {
    ...mapActions([
      'retrieveCandidateDocuments',
      'retrieveCandidateDocumentPreview',
      'retrieveCandidateById',
      'retrieveUserProfile',
      'setDefaultCandidateDocument',
      'downloadDocument',
      'deleteCandidateDocument',
      'retrieveCandidateUserProfile',
    ]),
    getIconColor(fileName) {
      const re = /(?:\.([^.]+))?$/;
      if (re.exec(fileName)[1] === 'pdf') {
        return '#ff0000';
      } else if (re.exec(fileName)[1] === 'docx' || re.exec(fileName)[1] === 'doc') {
        return '#005a9e';
      } else {
        return '#a7a7a77';
      }
    },
    setAsDefault(e) {
      console.log('setAsDefault: ', e.target.id);

      this.isLoading = true;
      this.setDefaultCandidateDocument({ uuid: e.target.id }).then(() => {
        this.retrieveCandidateUserProfile()
          .then(() => {
            this.isLoading = false;
          })
          .catch(() => {
            this.isLoading = false;
          });
      });
    },
    onOpenDocPreview(docId) {
      this.retrieveCandidateDocumentPreview({ uuid: docId, preview: 'true' }).then(response => {
        const blob = new window.Blob([response.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    },
    setDeleteDocument(doc) {
      this.documentToDelete = doc;
    },
    onDeleteDocument() {
      this.deleteCandidateDocument({ uuid: this.documentToDelete.id }).then(() => {
        this.retrieveCandidateUserProfile();

        this.$toasted.success(`File ${this.documentToDelete.name} was removed successfully.`, {
          theme: 'bubble',
          icon: 'fa-check-circle',
          position: 'bottom-right',
          duration: 5000,
        });
      });
    },
    onDownloadDocument(docId, docTitle) {
      this.retrieveCandidateDocumentPreview({ uuid: docId })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute('download', `${docTitle}`);
          document.body.appendChild(fileLink);

          fileLink.click();
        })
        .catch(err => {
          this.$toasted.error(errorService(err), {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
  },
  computed: {
    ...mapGetters(['getCandidateDocuments', 'getUserProfile', 'getDocumentPreview']),
  },
  mounted() {
    // this.retrieveCandidateDocuments();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables';
@import '@/assets/scss/_mixins';
/* Default select doc icon */
@include select-default-document-icon-styles;

.open-document {
  color: #000;
  cursor: pointer;
}
.add-document {
  position: relative;
  h5 {
    font-size: 2rem;
  }
  .list-unstyled {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0 20px 20px 20px;
    font-family: $font-family-sans-lato;
    max-height: 60vh;
    overflow-y: auto;
    li {
      position: relative;
      border-bottom: 1px solid #ddd;
      padding: 20px 0;
      font-size: 16px;
      .fa-crown {
        position: absolute;
        top: 5px;
        left: 4px;
        font-size: 17px;
        color: #a7a7a7;
        margin: 0 25px 0 5px;
        cursor: pointer;
      }
      span.d-flex {
        padding-left: 60px;
      }

      .btn {
        background: none !important;
        border: none !important;
        color: #000;
        box-shadow: none !important;
      }
      &:nth-child(2n) {
        background: rgba(0, 0, 0, 0.06);
      }
    }
  }
  .modal-title {
    font-size: 1.25rem;
  }
}

@media only screen and (max-width: 992px) {
  .add-document {
    .container {
      max-width: 100%;
      .list-unstyled {
        li {
          background: #fff !important;
          .col-md-3 {
            padding: 0 !important;
          }
          .hide-on-mobile {
            display: none !important;
          }
          .fa-crown {
            margin: 0 6px 0 0;
          }
          .date {
            font-size: 14px;
            color: #666;
            display: inline-block;
            margin-top: 15px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .add-document {
    .container {
      max-width: 100%;
      .list-unstyled {
        li {
          position: relative;
          .mobile-fix {
            position: absolute;
            right: 0;
            bottom: 25px;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 576px) {
  .add-document {
    .list-unstyled {
      li {
        margin-left: 0;
        margin-right: 0;

        .text-center {
          text-align: left !important;
          margin-top: 6px !important;
          .btn:first-of-type {
            padding-left: 0;
          }
        }
      }
    }
  }
}
/* Delete Modal */
.modal-body {
  .form-control {
    padding: 6px 12px !important;
    height: 42px !important;
  }
  .btn-outline-success {
    height: 40px;
  }
  .custom-checkbox {
    margin: 20px 0 5px 0;
  }
}
</style>
